import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel } from './SectionLabel';
import { Bloom } from './Bloom';
import { onboardingSteps } from '../data/howItWorks';
export function Onboarding() {
  return <section className="relative isolate overflow-hidden border-b border-[#1a1a1a] bg-[#0c0c0c]" data-id="element-443" data-mp="2r5ujxcibcxnf">
      <Bloom size="md" className="left-0 top-[-6rem]" data-id="element-444" data-mp="2w2tbpoei8sig" />
      <div className="mx-auto w-full max-w-6xl px-6 py-20 lg:py-24" data-id="element-445" data-mp="1zdlpsf9z4he0">
        <SectionLabel data-id="element-446" data-mp="1zfgbvwwzefjo">Onboarding</SectionLabel>
        <h2 className="mt-8 max-w-2xl text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-447" data-mp="23exg6n0o96n9">
          Live in about a week, without a manual to read.
        </h2>
        <p className="mt-5 max-w-2xl text-lg leading-relaxed text-neutral-400" data-id="element-448" data-mp="2d508ekzyygkj">
          Setup happens with you on a call, and you leave knowing how to run it.
        </p>

        <ol className="mt-14 grid grid-cols-1 gap-x-10 gap-y-10 md:grid-cols-3" data-id="element-449" data-mp="1fpco9emjiz1u">
          {onboardingSteps.map((s, i) => <motion.li key={s.title} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.06
        }} className="relative border-l border-[#1f1f1f] pl-7" data-id="element-450" data-mp="3ucryvb8w95q6" data-mpi={i}>
              <span className="absolute -left-[5px] top-1.5 h-2.5 w-2.5 rounded-full bg-emerald-500" aria-hidden="true" data-id="element-451" data-mp="3gkljvshh94sb" />
              <p className="font-mono text-xs tracking-[0.2em] text-neutral-600" data-id="element-452" data-mp="36mpbv9ju6pyf">
                {String(i + 1).padStart(2, '0')}
              </p>
              <h3 className="mt-3 text-lg font-semibold text-white" data-id="element-453" data-mp="32lvnyg6e9b5j">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-neutral-400" data-id="element-454" data-mp="2xnu3prx8f5sh">{s.body}</p>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}